<template>
  <div class="pt-2">
    <v-card flat>
      <v-form>
        <v-row no-gutters align="center" justify="space-around">
          <v-col cols="12" sm="1" style="text-align: right">
            <label>选择门店：</label>
          </v-col>
          <v-col cols="12" sm="2">
            <pd-shop-multiple-list
                v-model="filter.shopIds"
                isSearch
            ></pd-shop-multiple-list>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>选择年度：</label>
          </v-col>
          <v-col cols="12" sm="2">
            <el-date-picker
                v-model="filter.year"
                type="year"
                placeholder="选择年"
                format="yyyy 年"
                value-format="yyyy">
            </el-date-picker>
          </v-col>
          <template v-if="queryType=='1'">
            <v-col cols="12" sm="1" style="text-align: right">
              <label>选择月份：</label>
            </v-col>
            <v-col cols="12" sm="2">
              <v-select
                  v-model="filter.month"
                  :items="monthList"
                  item-text="name"
                  item-value="id"
                  clearable
                  outlined
                  dense
              ></v-select>
            </v-col>
          </template>
          <template v-else>
            <v-col cols="12" sm="1" style="text-align: right">
              <label>选择季度：</label>
            </v-col>
            <v-col cols="12" sm="2">
              <v-select
                  v-model="filter.quarter"
                  :items="quarterList"
                  item-text="name"
                  item-value="id"
                  clearable
                  outlined
                  dense
              ></v-select>
            </v-col>
          </template>
          <v-col cols="12" sm="2">
            <v-btn color="primary" class="mr-2" depressed @click="handleSearch"
            >查询
            </v-btn
            >
            <v-btn depressed @click="handleResetSearch">重置</v-btn>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="1"></v-col>

        </v-row> -->
      </v-form>
      <v-data-table
          :headers="headers"
          fixed-header
          :items="desserts"
          class="elevation-1 mt-2"
          :loading="loading"
          :server-items-length="totalDesserts"
          :page.sync="filter.pageNum"
          :items-per-page.sync="filter.pageSize"
          @update:page="handlePageChanged"
          @update:items-per-page="handlePageSizeChanged"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row no-gutters align="center" justify="space-between">
              <div>
                <v-btn color="primary" :disabled="!_hasButtonPermission('导出')" depressed class="mr-2"
                       @click="handleExport">
                  导出
                </v-btn>
              </div>
              <div>
                <v-radio-group
                    v-model="queryType"
                    row
                >
                  <v-radio
                      label="按月份"
                      value="1"
                  ></v-radio>
                  <v-radio
                      label="按季度"
                      value="2"
                  ></v-radio>
                </v-radio-group>
              </div>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          {{ _jungleStatus(item.status) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn text color="primary" small @click="viewDetail(item)"
          >查看
          </v-btn
          >
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import {default as BudgetCostReachApi} from "@/api/pd/budget/BudgetCostReachApi.js";
import downloadUtil from "@/util/downloadUtil.js";

export default {
  props: {
    buttonPriviledgeList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      monthList: [
        {id: 1, name: "一月"},
        {id: 2, name: "二月"},
        {id: 3, name: "三月"},
        {id: 4, name: "四月"},
        {id: 5, name: "五月"},
        {id: 6, name: "六月"},
        {id: 7, name: "七月"},
        {id: 8, name: "八月"},
        {id: 9, name: "九月"},
        {id: 10, name: "十月"},
        {id: 11, name: "十一月"},
        {id: 12, name: "十二月"}
      ],
      quarterList: [
        {id: 1, name: "一季度"},
        {id: 2, name: "二季度"},
        {id: 3, name: "三季度"},
        {id: 4, name: "四季度"}
      ],
      filter: {
        shopIds: [],
        year: null,
        month: null,
        quarter: null,
        pageNum: 1,
        pageSize: 15
      },
      queryType: '1', // 默认按月份
      headers: [
        {
          text: "预算编号",
          value: "costId",
          sortable: false,
          width: 90,
          divider: true,
        },
        {
          text: "门店名称",
          value: "shopName",
          sortable: false,
          width: 180,
          divider: true,
        },
        {
          text: "年度",
          sortable: false,
          value: "year",
          width: 100,
          divider: true,
        },
        {
          text: "月份",
          sortable: false,
          value: "month",
          width: 100,
          divider: true,
        },
        {
          text: "月度预算总额",
          sortable: false,
          value: "budgetFee",
          width: 140,
          divider: true,
        },
        {
          text: "月度实际已用总额",
          sortable: false,
          value: "actualFee",
          width: 150,
          divider: true,
        },
        {
          text: "月度达成率",
          align: "start",
          sortable: false,
          value: "monthReach",
          width: 120,
          divider: true,
        },
        {
          text: "年度预算总额",
          align: "start",
          sortable: false,
          value: "budgetFeeYear",
          width: 140,
          divider: true,
        },
        {
          text: "年度实际已用金额",
          align: "start",
          sortable: false,
          value: "actualFeeYear",
          width: 150,
          divider: true,
        },
        {
          text: "年度达成率",
          align: "start",
          sortable: false,
          value: "yearReach",
          width: 120,
          divider: true,
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
          width: 220,
          divider: true,
        },
      ],
      desserts: [],
      loading: false,
      totalDesserts: 0
    };
  },
  mounted() {
    // this.getDataFromApi();
  },
  watch: {
    queryType(val) {
      this.handleResetSearch()
      this.desserts = []
      if (val == '1') {
        this.headers = [
          {
            text: "预算编号",
            value: "costId",
            sortable: false,
            width: 90,
            divider: true,
          },
          {
            text: "门店名称",
            value: "shopName",
            sortable: false,
            width: 180,
            divider: true,
          },
          {
            text: "年度",
            sortable: false,
            value: "year",
            width: 100,
            divider: true,
          },
          {
            text: "月份",
            sortable: false,
            value: "month",
            width: 100,
            divider: true,
          },
          {
            text: "月度预算总额",
            sortable: false,
            value: "budgetFee",
            width: 140,
            divider: true,
          },
          {
            text: "月度实际已用总额",
            sortable: false,
            value: "actualFee",
            width: 150,
            divider: true,
          },
          {
            text: "月度达成率",
            align: "start",
            sortable: false,
            value: "monthReach",
            width: 120,
            divider: true,
          },
          {
            text: "年度预算总额",
            align: "start",
            sortable: false,
            value: "budgetFeeYear",
            width: 140,
            divider: true,
          },
          {
            text: "年度实际已用金额",
            align: "start",
            sortable: false,
            value: "actualFeeYear",
            width: 150,
            divider: true,
          },
          {
            text: "年度达成率",
            align: "start",
            sortable: false,
            value: "yearReach",
            width: 120,
            divider: true,
          },
          {
            text: "操作",
            align: "start",
            sortable: false,
            value: "actions",
            width: 220,
            divider: true,
          },
        ]
      } else {
        this.headers = [
          {
            text: "预算编号",
            value: "costId",
            sortable: false,
            width: 90,
            divider: true,
          },
          {
            text: "门店名称",
            value: "shopName",
            sortable: false,
            width: 180,
            divider: true,
          },
          {
            text: "年度",
            sortable: false,
            value: "year",
            width: 100,
            divider: true,
          },
          {
            text: "季度",
            sortable: false,
            value: "quarter",
            width: 100,
            divider: true,
          },
          {
            text: "季度预算总额",
            sortable: false,
            value: "budgetFee",
            width: 140,
            divider: true,
          },
          {
            text: "季度实际已用总额",
            sortable: false,
            value: "actualFee",
            width: 150,
            divider: true,
          },
          {
            text: "季度达成率",
            align: "start",
            sortable: false,
            value: "quarterReach",
            width: 120,
            divider: true,
          },
          {
            text: "年度预算总额",
            align: "start",
            sortable: false,
            value: "budgetFeeYear",
            width: 140,
            divider: true,
          },
          {
            text: "年度实际已用金额",
            align: "start",
            sortable: false,
            value: "actualFeeYear",
            width: 150,
            divider: true,
          },
          {
            text: "年度达成率",
            align: "start",
            sortable: false,
            value: "yearReach",
            width: 120,
            divider: true,
          },
          {
            text: "操作",
            align: "start",
            sortable: false,
            value: "actions",
            width: 220,
            divider: true,
          },
        ]
      }
    },
  },
  methods: {
    viewDetail(item) {
      this.$emit("viewDetailCallback", {formStatus: 'detail', costId: item.costId})
    },
    handleSearch() {
      // 校验门店必选
      if (!this.filter.shopIds || this.filter.shopIds.length == 0) {
        this.$dialog.error({
          title: '错误',
          text: '请选择门店'
        })
        return
      }
      this.getDataFromApi();
    },
    handleResetSearch() {
      this.filter = {
        shopIds: [],
        year: null,
        month: null,
        quarter: null,
        pageNum: 1,
        pageSize: 15
      };
      // this.getDataFromApi();
    },
    handlePageChanged(pageNum) {
      this.filter.pageNum = pageNum;
      this.getDataFromApi();
    },
    handlePageSizeChanged(pageSize) {
      if (pageSize == -1) {
        pageSize = 100;
      }
      this.filter.pageNum = 1;
      this.filter.pageSize = pageSize;
      this.getDataFromApi();
    },
    async getDataFromApi() {
      let me = this;
      me.loading = true;
      let queryUserResp;
      if (this.queryType == '1') {
        queryUserResp = await BudgetCostReachApi.list({
          shopIds: me.filter.shopIds.join(','),
          year: me.filter.year,
          month: me.filter.month,
          pageNum: me.filter.pageNum,
          pageSize: me.filter.pageSize
        });
      } else {
        queryUserResp = await BudgetCostReachApi.listQuarter({
          shopIds: me.filter.shopIds.join(','),
          year: me.filter.year,
          quarter: me.filter.quarter,
          pageNum: me.filter.pageNum,
          pageSize: me.filter.pageSize
        });
      }
      console.log("load user returned;");
      console.log(queryUserResp);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取预算达成率列表失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      if (!data.data || !data.data.rows) {
        me.loading = false;
        throw new Error("获取预算达成率列表情况失败(无会话数据)");
      }
      me.loading = false;
      me.desserts = data.data.rows;
      me.totalDesserts = data.data.total;
    },
    async handleExport() {
      let me = this;
      let res
      if (this.queryType == '1') {
        res = await BudgetCostReachApi.exportData({
          shopIds: me.filter.shopIds.join(','),
          year: me.filter.year,
          month: me.filter.month,
          pageNum: me.filter.pageNum,
          pageSize: me.filter.pageSize
        });
      } else {
        res = await BudgetCostReachApi.exportDataQuarter({
          shopIds: me.filter.shopIds.join(','),
          year: me.filter.year,
          quarter: me.filter.quarter,
          pageNum: me.filter.pageNum,
          pageSize: me.filter.pageSize
        });
      }
      downloadUtil.downloadByBlob({res: res.data, fileName: "预算达成率导出数据.xlsx"});
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList;
      let hasButton = false;
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == "Y") {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    }
  },
};
</script>
<style scoped>

</style>